import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import virtual_components from '@devices/settings/device_settings/virtual_components.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import plugs_app_settings from '@devices/settings/device_settings/plugs_app_settings.js';
import share from '@devices/settings/device_settings/share.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

const settings = {
	title: 'settings',
	components: [
		{ title: 'device_name', component: 'device_name_g2' },
		{
			title: 'operational_counters',
			component: 'operational_counters_g2',
			requires_operational_counters: true,
		},
		{
			title: 'reverse_measurement_direction',
			component: 'reverse_measurement_direction_g2_plug_pm',
		},
		{ title: 'firmware_version', component: 'firmware_update' },
		{ title: 'geo_location_and_time_zone', component: 'location_g2' },
		{ title: 'device_reboot', component: 'device_reboot' },
		{ title: 'factory_reset', component: 'factory_reset' },
		{ title: 'device_information', component: 'device_information' },
	],
};

export default {
	name: 'ShellyPlugCPMG4',
	friendly_name: 'Plug C PM Gen4',
	family: 'power_meter',
	isPM: true,
	modes: {
		power_meter: {
			channels: 1,
			notifications: ['offline', 'device_problem', 'overpower', 'overvoltage', 'overtemperature'],
			meters: 1,
			rollers: 0,
			control_holder: 0,
			default_icon: 'socket.png',
			settings: [
				scripts_gen_2,
				virtual_components,
				networks_gen_2_plus,
				bluetooth_gen_2,
				plugs_app_settings,
				share,
				settings,
			],
		},
	},
};
